import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/pro-regular-svg-icons";

/**
 * The heading row of the offboarding page: back arrow and title.
 *
 * @param {object} props
 * @param {() => void} props.onBack - Leaves the page without sending anything
 * @returns {JSX.Element} The heading row
 */
const OffboardingHeader = ({ onBack }) => (
  <div className="flex flex-row items-center pb-4">
    <button onClick={onBack} className="text-black flex">
      <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
    </button>
    <h2 className="border-l border-mute-200 pl-4">Offboard user</h2>
  </div>
);

export default OffboardingHeader;
